import type { Provider } from '@angular/core';

import { provideTellentAssistantRenderPresenter } from '@core/tellent-assistant-contracts';
import type { PresentTableArgs } from '@core/tellent-assistant-types';

import { PresentTableDataComponent } from '../present-table-data/present-table-data.component';

export const providePresentTableDataClientTool: Provider =
  provideTellentAssistantRenderPresenter<PresentTableArgs>({
    id: 'presentTableData',
    component: PresentTableDataComponent,
  });
